export { default } from './IntakeProgressDetails';
